module.exports = __webpack_public_path__ + "img/image-collection-sliding-overlays-kia.65ff95cd.png";